import React from 'react';
import { Link } from 'react-router-dom';
import { ASSESSMENT_URL } from './shared';

/** Closing CTA band — dark card funneling into the demo booking form. */
const BookingCta = () => (
  <section id="book-strategy" aria-labelledby="mpa-cta-heading" className="mpa-bookcta">
    <div className="mpa-container">
      <div className="mpa-bookcta-card">
        <div className="mpa-bookcta-body">
          <p className="mpa-bookcta-eyebrow">Book a FREE transition strategy meeting</p>
          <h2 id="mpa-cta-heading" className="mpa-bookcta-title">
            Let&apos;s build your roadmap from marketplace host to independent rental operator.
          </h2>
          <p className="mpa-bookcta-sub">
            Tell us about your rental operation, and we&apos;ll build your custom transition plan.
          </p>

          <Link to={ASSESSMENT_URL} className="mpa-cta mpa-bookcta-btn">
            Build My Transition Plan
          </Link>
          <p className="mpa-bookcta-note">Takes about 2 minutes. No obligation.</p>
        </div>
      </div>
    </div>
  </section>
);

export default BookingCta;
